import React, { useState, useEffect } from 'react'
import moment from "moment";
import { Tabs, Card, Form, Row, Col, Select, DatePicker, TimePicker, Modal, message } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import { PlusOutlined } from '@ant-design/icons'
import { getOTACodes } from '../../../../services/common'
import { updateRecreationSchedule, deleteRecreation } from '../../../../services/recreation'
import { LocalPersistence } from '../../../../factories';
import PageContainer from '../../../CSIComponents/PageContainer';
import Loading from '../../../Loading';
import Collapse, {Panel} from '../../../ui/Collapse';
import ActionButtonsBar from '../../../ui/ActionButtonsBar'

const { TabPane } = Tabs;

const { Option } = Select;
const FormItem = Form.Item

let newTabIndex = 10;

let newTabIndexArr: any = [];

const defaultOperationTime = [
  { dayoftheweek: "Mon", endtime: null, starttime: "" },
  { dayoftheweek: "Tue", endtime: null, starttime: "" },
  { dayoftheweek: "Wed", endtime: null, starttime: "" },
  { dayoftheweek: "Thu", endtime: null, starttime: "" },
  { dayoftheweek: "Fri", endtime: null, starttime: "" },
  { dayoftheweek: "Sat", endtime: null, starttime: "" },
  { dayoftheweek: "Sun", endtime: null, starttime: "" }
] as {}[]

const ScheduleAndChargeEdit = (props: any) => {
  const initialPanes = props.editData;
  const dateFormat = 'MM/DD/YYYY';
  const itemFormat = 'HH:mm';
  // let [newTabIndex, setNewTabIndex] = useState(0);
  const [form] = Form.useForm();
  const [activeKey, setActiveKey] = useState("0");

  useEffect(() => {
    initialPanes.forEach((item: any, index: number) => {
      if (item.operationtime.length < 1) {
        item.operationtime = defaultOperationTime
      }
      item.closable = true;
      item.id = index;
      item.startDatePicker = item.startdate && item.enddate ? [moment(item.startdate, dateFormat), moment(item.enddate, dateFormat)] : [];
      item.operationtime.forEach((cell: any, oIndex: any) => {
        cell.starttime = cell.starttime ? moment(cell.starttime, itemFormat) : ""
        cell.endtime = cell.endtime ? moment(cell.endtime, itemFormat) : ""
      })
      item.charge.forEach((cell: any, oIndex: any) => {
        cell.id = oIndex + 1
      })
    })
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  if (initialPanes.length === 1) {
    initialPanes[0].closable = false;
  }
  const [panes, setPanes] = useState(initialPanes);
  const [addId, setAddId] = useState(panes.length);
  const [editFlag, setEditFlag] = useState(false);
  //const [disabledFlag, setDisabledFlag] = useState<any>(false)
  const data = initialPanes || []
  //const getDefaultOpenKeys = (data: dataType[]) => Array.from(data).map((v, k) => k);
  const [detailData, setDetailData] = useState(data)
  const [addLoading, setAddLoading] = useState(true)
  //const [defaultOpenKeys, setDefaultOpenKeys] = useState(getDefaultOpenKeys(detailData))
  const [refreshCount, setRefreshCount] = useState(0)
  const [currencyList, setCurrencyList] = useState<Array<any>>([]);
  const [chargeUnitList, setChargeUnitList] = useState<Array<any>>([]);
  const [ChargeFrequency, setChargeFrequency] = useState<Array<any>>([]);
  const [disabledStatus, setDisabledStatus] = useState(true)
  const [requiredFlag, setRequiredFlag] = useState(true)

  const onChange = (activeKey: any) => {
    setActiveKey(activeKey);
    props.getClickTabs(activeKey)
  };

  const onEdit = (targetKey: any, action: any) => {
    action === 'add' ? add() : remove(targetKey);
  };
  const onChangeItem = () => {
    setRequiredFlag(true)
  }
  useEffect(() => {
    newTabIndex = panes.length > 0 ? panes.length - 1 : 0;
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  const add = async () => {
    newTabIndex = panes.length > 0 ? Number(panes.length - 1) : 0;
    const newKey = ++newTabIndex;
    newTabIndexArr.push(newKey)
    const newPanes = JSON.parse(JSON.stringify(panes));
    let id = addId

    let obj = {
      "startdate": "",
      "enddate": "",
      'startDatePicker': [],
      'id': id,
      "operationtime": [
        {
          "dayoftheweek": "Mon",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Tue",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Wed",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Thu",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Fri",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Sat",
          "starttime": "",
          "endtime": ""
        }, {
          "dayoftheweek": "Sun",
          "starttime": "",
          "endtime": ""
        }
      ],
      "charge": [
        {
          "type": "",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": "",
          'id': 1
        },
      ],
      closable: true
    }
    newPanes[0].closable = true;
    id++
    setAddId(id)
    newPanes.push(obj);
    setActiveKey(JSON.stringify(newKey));
    setPanes(newPanes);
    setRequiredFlag(true)
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const remove = (targetKey: any) => {
    //let deleteTabName = panes.filter((item: any, index: any) => targetKey == index)
    let daleteTitle = ""
    panes.forEach((pane: any, i: any) => {
      if (i === targetKey) {
        daleteTitle = pane.id;
      }
    });
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      transitionName: "",
      maskTransitionName: "",
      content: `Are you sure you want to delete Schedule ${daleteTitle + 1}?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk() {
        let newActiveKey = targetKey;
        let lastIndex = 0;
        panes.forEach((pane: any, i: any) => {
          if (i === targetKey) {
            lastIndex = i - 1;
          }
        });
/*         panes.length===1 && form.resetFields() */
        const newPanes = panes.filter((pane: any, i: any) => i !== Number(targetKey));
        if (newPanes.length && targetKey) {
          if (lastIndex >= 0) {
            newActiveKey = JSON.stringify(newPanes.length - 1);
            newTabIndex--
          } else {
            newActiveKey = "0";
          }
        }
        if (newPanes.length === 1) {
          newPanes[0].closable = false;
        }
        if (newPanes.length === 0) {
          form.resetFields();
          setRequiredFlag(false)
          validateFieldsError()
          return;
        }
        setActiveKey(newActiveKey);
        setPanes(newPanes);
      },
      onCancel() {

      },
    });



  };
  //let newValue = [{}]
  const deleteItem = (index: number, paneIndex: number) => {
    const _detailData = JSON.parse(JSON.stringify(panes))
    for (let i = 0; i < _detailData.length; i++) {
      if (i === paneIndex) {
        for (let j = 0; j < _detailData[i].charge.length; j++) {
          if (j === index) {
            let deleteItem = _detailData[i].charge.filter((item: any) => {
              return item.type != null
            })
            if (deleteItem.length === 1) {
              _detailData[i].charge.forEach((item: any, ind: number) => {
                if (item.id === deleteItem[0].id) {
                  item.type = "";
                  item.charge = "";
                  item.currency = "";
                  item.chargeunit = "";
                  item.chargefrequency = "";
                }
              });
              _detailData.forEach((item: any) => {
                item.closable = true;
                item.startDatePicker = item.startdate && item.enddate ? [moment(item.startdate, dateFormat), moment(item.enddate, dateFormat)] : [];
                item.operationtime.forEach((cell: any) => {
                  if (cell.starttime) {
                    let startH = new Date(cell.starttime).getHours()
                    let startM = new Date(cell.starttime).getMinutes()
                    cell.starttime = moment(('0' + startH).slice(-2) + ':' + ('0' + startM).slice(-2) + '', itemFormat)

                  } else {
                    cell.starttime = ""
                  }
                  if (cell.endtime) {
                    let endH = new Date(cell.endtime).getHours()
                    let endM = new Date(cell.endtime).getMinutes()
                    cell.endtime = moment(('0' + endH).slice(-2) + ':' + ('0' + endM).slice(-2) + '', itemFormat)
                  } else {
                    cell.endtime = ""
                  }
                })
              })
              setRequiredFlag(false)
              setPanes(_detailData)
              form.setFieldsValue(_detailData)
              return
            } else {
              _detailData[i].charge[j].type = null
              const filterData = _detailData[0].charge.filter(({ type } : { type: string }) => type !== null)
              const newDetailData = [{
                ..._detailData[0],
                charge: filterData
              }]
              setPanes(newDetailData)
            }
          }

        }
      }
    }
  }


  const addCertification = () => {
    let addCertificationData = JSON.parse(JSON.stringify(panes))
    for (let i = 0; i < addCertificationData.length; i++) {
      if (i === Number(activeKey)) {
        addCertificationData[i].charge.push({
          "type": " ",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": "",
          'id': panes[activeKey].charge.length + 1

        })
      }
      setPanes(addCertificationData)
    }
    setRefreshCount(refreshCount + 1)
    setRequiredFlag(true)

  }
  const getCurrencyist = async () => {
    setAddLoading(true)
    let res = await getOTACodes('CUR', '')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length !== 0) {

      res.otacodes.map((item: any) => item.key = item.codeName)
      setCurrencyList(res.otacodes)
      setAddLoading(false)
    } else {
      message.error({
        content: res?.error[0]?.message || 'operation failed'
      });
      setCurrencyList([])
    }
  }
  const getChargeUnitList = async () => {
    setAddLoading(true)
    let res = await getOTACodes('CHG ', 'ChargeUnit')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length !== 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setChargeUnitList(res.otacodes)
      setAddLoading(false)
    } else {
      message.error({
        content: res?.error[0]?.message || 'operation failed'
      });
      setChargeUnitList([])
    }


  }
  const getChargeFrequencyList = async () => {
    setAddLoading(true)
    let res = await getOTACodes('CHG ', 'ChargeFrequency')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length !== 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setChargeFrequency(res.otacodes)
      setAddLoading(false)
    } else {
      message.error({
        content: res?.error[0]?.message || 'operation failed'
      });
      setChargeFrequency([])
    }
  }
  const validateFieldsError = () => {
    form.validateFields().then((values) => {
      setDisabledStatus(false)
    },err=>{
      if(!!err.errorFields.length){
        setDisabledStatus(true)
      }else{
        setDisabledStatus(false)
      }
    }).catch(() => {
      const detailErrNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
      if (detailErrNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }
    })
  }
  useEffect(() => {
    validateFieldsError()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [panes,addLoading, currencyList, chargeUnitList, ChargeFrequency])

  const addSave = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()

    form.validateFields().then(async (value) => {
      for (let key in value) {
        value[key].startdate = (value[key].startDatePicker && value[key].startDatePicker.length > 0) && value[key].startDatePicker !== undefined ? (value[key].startDatePicker[0]).format('MM/DD/YYYY') : ''
        value[key].enddate = (value[key].startDatePicker && value[key].startDatePicker.length > 0) && value[key].startDatePicker !== undefined ? (value[key].startDatePicker[1]).format('MM/DD/YYYY') : ''
        value[key].startDatePicker = null;
        if(!value[key].charge) {
          const tempCharge: Object[] = [];
          tempCharge.push({
            "type": " ",
            "chargeunit": "",
            "chargefrequency": "",

          })
          value[key].charge = tempCharge;
        }
        for (let i = 0; i < value[key].charge.length; i++) {
          if (value[key].charge[i] === undefined) {
            value[key].charge.splice(i, 1)
            i--
          }
        }
        if (!value[key].description) {
          value[key].description = ""
        }
        for (let i = 0; i < value[key].operationtime.length; i++) {
          if (i === 0) {
            value[key].operationtime[i].dayoftheweek = 'Mon'
          } else if (i === 1) {
            value[key].operationtime[i].dayoftheweek = 'Tue'
          } else if (i === 2) {
            value[key].operationtime[i].dayoftheweek = 'Wed'
          } else if (i === 3) {
            value[key].operationtime[i].dayoftheweek = 'Thu'
          } else if (i === 4) {
            value[key].operationtime[i].dayoftheweek = 'Fri'
          } else if (i === 5) {
            value[key].operationtime[i].dayoftheweek = 'Sat'
          } else if (i === 6) {
            value[key].operationtime[i].dayoftheweek = 'Sun'
          }

          if (value[key].operationtime[i].endtime !== "" && value[key].operationtime[i].endtime !== undefined && value[key].operationtime[i].endtime !== null) {

            value[key].operationtime[i].endtime = value[key].operationtime[i].endtime.format('HH:mm')
          } else {
            //delete value[key].operationtime[i]
            //value[key].operationtime[i] = undefined
            value[key].operationtime[i].endtime = ""
          }
          if (value[key].operationtime[i].starttime !== "" && value[key].operationtime[i].starttime !== undefined && value[key].operationtime[i].starttime !== null) {

            value[key].operationtime[i].starttime = value[key].operationtime[i].starttime.format('HH:mm')
          } else {
            //delete value[key].operationtime[i]
            // value[key].operationtime[i] = undefined
            value[key].operationtime[i].starttime = ""
          }
        }
        for (let j = 0; j < value[key].charge.length; j++) {
          if (value[key].charge[j].type === undefined) {
            value[key].charge[j].type = ""
          }
          if (value[key].charge[j].chargefrequency === undefined) {
            value[key].charge[j].chargefrequency = ""
          }
          if (value[key].charge[j].chargefrequency === undefined) {
            value[key].charge[j].chargefrequency = ""
          }
        }
      }
      for (let key in value) {
        if (value[key].startdate === '') {
          delete value[key].startdate;
        }
        if (value[key].enddate === "") {
          delete value[key].enddate;
        }
      }
      let editChargeData = [];
      for (let key in value) {
        editChargeData.push(value[key])
      }
      const param = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "recreations": [
            {
              "recreationid": props.info.recreationid,
              "recreationlangid": props.info.recreationlangid,
              "schedule": editChargeData
            }
          ]
        }
      }
      setAddLoading(true)
      const res = await updateRecreationSchedule(param);
      if (res.result.success) {

        setDetailData(editChargeData)
        props.gerEditData(editChargeData)
        // form.resetFields();
        props.setDisabledFlag(false)
        // changeInitData = JSON.parse(JSON.stringify(editChargeData))
        props.editPageCancelBtnClick();
        setEditFlag(!editFlag); props.cancelEditable();
        setAddLoading(false)
        // props.handelCancelBtnClick();
      } else {
        message.error({
          content: res?.error[0]?.message || 'operation failed'
        });
      }
    })
  }
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    var bodyData = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "recreations": [
          {
            "recreationid": props.info.recreationid,
            "recreationlangid": props.info.recreationlangid

          }
        ]
      }
    }
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete this record?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      async onOk() {
        const res = await deleteRecreation(bodyData);
        if (res.result.success) {
          // let data = detailData.splice(activeKey, 1)
          setDetailData(detailData)
          props.editPageCancelBtnClick();
          props.cancelEditable();
          props.cancelAndSave();
        }
      },
      onCancel() {

      },
    });

  }
  useEffect(() => {
    getCurrencyist()
    getChargeUnitList()
    getChargeFrequencyList()
    form.setFieldsValue(panes)
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])


  const handlCancelClick = () => {
    props.setDisabledFlag(false)
    props.setEditToDetail()
}
  const typeChange = (value: any, cardIndex: number) => {
    setRequiredFlag(true)
  }

  if (addLoading) return <Loading type="large" />
  return (currencyList.length > 0 && chargeUnitList.length > 0) ||
    ChargeFrequency.length > 0 ? (
    <PageContainer>
      <Card style={{ marginBottom: '100px' }}>
        <Form
          form={form}
          layout='vertical'
          //initialValues={panes}
          onValuesChange={validateFieldsError}>
          <Tabs
            type='editable-card'
            onChange={onChange}
            activeKey={activeKey}
            onEdit={onEdit}>
            {panes.map((schedule: any, index: any) => {
              return (
                <TabPane
                  tab={'Schedule ' + (schedule.id + 1)}
                  key={index}
                  forceRender={true}>
                  <Card>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          name={[schedule.id, 'startDatePicker']}
                          label='Start Date ~ End Date'>
                          <DatePicker.RangePicker
                            onChange={onChangeItem}
                            format={dateFormat}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}></Col>
                    </Row>
                    <Row gutter={24}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column-reverse',
                            marginRight: 5,
                            fontWeight: 'bold',
                          }}>
                          <div style={{ height: 35 }}>Close</div>
                          <div style={{ height: 35 }}>Open</div>
                        </div>

                        {schedule.operationtime.map(
                          (operationtime: any, j: number) => {
                            return (
                              <div
                                style={{ flex: 1, userSelect: 'none' }}
                                key={index}>
                                <div style={{ fontSize: 14, fontWeight: 500 }}>
                                  {operationtime.dayoftheweek}
                                </div>
                                <div
                                  style={{
                                    display: 'none',
                                    fontSize: 14,
                                    fontWeight: 500,
                                  }}>
                                  <FormItem
                                    name={[
                                      schedule.id,
                                      'operationtime',
                                      j,
                                      'dayoftheweek',
                                    ]}>
                                    <Input
                                      value={operationtime.dayoftheweek}
                                      style={{
                                        border: '0',
                                        color: '#333',
                                        backgroundColor: '#fff',
                                      }}
                                      disabled
                                    />
                                  </FormItem>
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    textAlign: 'center',
                                    border: '1px solid #bbb',
                                    padding: '20 0',
                                  }}>
                                  <div
                                    style={{
                                      height: 40,
                                      lineHeight: '40px',
                                      width: '80%',
                                      margin: 'auto',
                                      cursor: 'pointer',
                                    }}>
                                    <FormItem
                                      name={[
                                        schedule.id,
                                        'operationtime',
                                        j,
                                        'starttime',
                                      ]}>
                                      <TimePicker
                                        onChange={onChangeItem}
                                        format={itemFormat}
                                      />
                                    </FormItem>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    textAlign: 'center',
                                    border: '1px solid #bbb',
                                    borderTop: '0',
                                    padding: '20 0',
                                  }}>
                                  <div
                                    style={{
                                      height: 40,
                                      lineHeight: '40px',
                                      width: '80%',
                                      margin: 'auto',
                                      cursor: 'pointer',
                                    }}>
                                    <FormItem
                                      name={[
                                        schedule.id,
                                        'operationtime',
                                        j,
                                        'endtime',
                                      ]}>
                                      <TimePicker
                                        onChange={onChangeItem}
                                        format={itemFormat}
                                      />
                                    </FormItem>
                                  </div>
                                </div>
                              </div>
                            )
                          },
                        )}
                      </div>
                    </Row>
                    <Row gutter={24} style={{ marginTop: '12px' }}>
                      <Col span={18}>
                        <Form.Item
                          label='Description'
                          name={[schedule.id, 'description']}
                          rules={[
                            {
                              max: 300,
                              message:
                                'You have reached the max character length of 300',
                            }
                          ]}>
                          <TextArea
                            maxLength={300}
                            rows={3}
                            onChange={onChangeItem}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Collapse
                      defaultActiveKey={schedule.charge.map(
                        (_: object, i: number) => i,
                      )}
                      multiCollapseButton
                      key={refreshCount}
                      style={{ marginTop: '30px' }}>
                      <>
                        {schedule.charge.map((charge: any, v: number) => {
                          return (
                            <React.Fragment key={v}>
                              {charge.type !== '  ' && charge.type != null ? (
                                <Panel
                                  collapsible='header'
                                  header={`Charge ${v + 1}`}
                                  key={v}
                                  deleteButton={{
                                    action: () => deleteItem(v, index),
                                    title: `Are you sure you want to delete Charge ${
                                      v + 1
                                    }?`,
                                  }}>
                                  <Row gutter={24}>
                                    <Col span={6} key={`col1${v}`}>
                                      <FormItem
                                        name={[
                                          schedule.id,
                                          'charge',
                                          v,
                                          'type',
                                        ]}
                                        label='Charge Type'>
                                        <Select allowClear onChange={(value) =>
                                            typeChange(value, index)
                                          }
                                          showSearch>
                                          <Option value='Amount'>Amount</Option>
                                          <Option value='Percent'>
                                            Percent
                                          </Option>
                                        </Select>
                                      </FormItem>
                                    </Col>
                                    <Col span={6} className='col-margin'>
                                      <Form.Item shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                          switch (
                                            getFieldValue([
                                              schedule.id,
                                              'charge',
                                              v,
                                              'type',
                                            ])
                                          ) {
                                            case 'Amount':
                                              return (
                                                <>
                                                  <FormItem
                                                    style={{
                                                      marginBottom: '2px',
                                                    }}
                                                    name={[
                                                      schedule.id,
                                                      'charge',
                                                      v,
                                                      'charge',
                                                    ]}
                                                    label={'Charge (Amount)'}
                                                    rules={[
                                                      {
                                                        required: requiredFlag,
                                                        message:
                                                          'This field is required',
                                                      },
                                                      {
                                                        pattern:
                                                          /^\d*(\.\d*)?$/,
                                                        message:
                                                          'This field should be a number.',
                                                      },
                                                    ]}>
                                                    <Input />
                                                  </FormItem>{' '}
                                                  <span
                                                    style={{
                                                      color: '#06789D',
                                                    }}>
                                                    Please input the amount
                                                    value for each charge. Input
                                                    0 if free of charge, or
                                                    leave the field blank if not
                                                    applicable.
                                                  </span>
                                                </>
                                              )
                                            case 'Percent':
                                              return (
                                                <FormItem
                                                  name={[
                                                    schedule.id,
                                                    'charge',
                                                    v,
                                                    'charge',
                                                  ]}
                                                  label={'Charge (Percent)'}
                                                  rules={[
                                                    {
                                                      required: requiredFlag,
                                                      message:
                                                        'This field is required',
                                                    },
                                                    {
                                                      pattern: /^\d*(\.\d*)?$/,
                                                      message:
                                                        'This field should be a number.',
                                                    },
                                                  ]}>
                                                  <Input />
                                                </FormItem>
                                              )
                                            default:
                                              return null
                                          }
                                        }}
                                      </Form.Item>
                                    </Col>
                                    <Col span={6} key={`col3${v}`}>
                                      <Form.Item shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                          switch (
                                            getFieldValue([
                                              schedule.id,
                                              'charge',
                                              v,
                                              'type',
                                            ])
                                          ) {
                                            case 'Amount':
                                              return (
                                                <FormItem
                                                  name={[
                                                    schedule.id,
                                                    'charge',
                                                    v,
                                                    'currency',
                                                  ]}
                                                  label='Currency'
                                                  rules={[
                                                    {
                                                      required: requiredFlag,
                                                      message:
                                                        'This field is required',
                                                    },
                                                  ]}>
                                                  <Select allowClear showSearch>
                                                    {currencyList.length > 0 &&
                                                      currencyList.map(
                                                        (
                                                          item: any,
                                                          index: any,
                                                        ) => {
                                                          return (
                                                            <Option
                                                              key={index}
                                                              value={
                                                                item.codeName
                                                              }>
                                                              {item.codeName}
                                                            </Option>
                                                          )
                                                        },
                                                      )}
                                                  </Select>
                                                </FormItem>
                                              )
                                            default:
                                              return null
                                          }
                                        }}
                                      </Form.Item>
                                    </Col>
                                    <Col></Col>
                                  </Row>
                                  <Row gutter={24}>
                                    <Col span={6} key={`col4${v}`}>
                                      <FormItem
                                        name={[
                                          schedule.id,
                                          'charge',
                                          v,
                                          'chargeunit',
                                        ]}
                                        label='Charge Unit'>
                                        <Select allowClear onChange={onChangeItem}
                                          showSearch>
                                          {chargeUnitList.length > 0 &&
                                            chargeUnitList.map(
                                              (item: any, index: any) => {
                                                return (
                                                  <Option
                                                    key={index}
                                                    value={item.codeName}>
                                                    {item.codeName}
                                                  </Option>
                                                )
                                              },
                                            )}
                                        </Select>
                                      </FormItem>
                                    </Col>
                                    <Col span={6} key={`col5${v}`}>
                                      <FormItem
                                        name={[
                                          schedule.id,
                                          'charge',
                                          v,
                                          'chargefrequency',
                                        ]}
                                        label='Charge Frequency'>
                                        <Select allowClear onChange={onChangeItem}
                                          showSearch>
                                          {ChargeFrequency.length > 0 &&
                                            ChargeFrequency.map(
                                              (item: any, index: any) => {
                                                return (
                                                  <Option
                                                    key={index}
                                                    value={item.codeName}>
                                                    {item.codeName}
                                                  </Option>
                                                )
                                              },
                                            )}
                                        </Select>
                                      </FormItem>
                                    </Col>
                                  </Row>
                                </Panel>
                              ) : null}
                            </React.Fragment>
                          )
                        })}
                      </>
                    </Collapse>
                  </Card>

                  <span
                    style={{
                      marginBottom: '10px',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      addCertification()
                    }}>
                    <PlusOutlined style={{ marginRight: 4 }} />
                    Add Charge { panes[0].charge.length + 1 }
                  </span>
                </TabPane>
              )
            })}
          </Tabs>
        </Form>
        <ActionButtonsBar
          onDelete={DeleteClick}
          onCancel={handlCancelClick}
          onSave={addSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </Card>
    </PageContainer>
  ) : (
    <></>
  )
}

export default ScheduleAndChargeEdit;

